import { TextField, FormHelperText } from "@mui/material";
import React from "react";

interface IInputProps {
  value?: string;
  direction?: "rtl" | "ltr";
  name?: string;
  handelChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string | false;
  placHolder?: string;
  textArea?: boolean;
  placHolderSize?: number;
}

export default function CustomInput({
  textArea = false,
  direction = "rtl",
  handelChange,
  name,
  error,
  errorMessage,
  placHolder = "نام کاربری خود را وارد کنید...",
  placHolderSize = 14,
  value,
}: IInputProps) {
  return (
    <TextField
      value={value}
      rows={6}
      multiline={textArea}
      helperText={
        <FormHelperText
          style={{
            padding: "0px",
            margin: "0px",
            color: "red",
            direction: "rtl",
            textAlign: "right",
            fontSize: 13,
          }}
        >
          {errorMessage}
        </FormHelperText>
      }
      error={error}
      name={name}
      onChange={handelChange}
      placeholder={placHolder}
      InputLabelProps={{ shrink: false }}
      size="medium"
      id="outlined-basic"
      variant="outlined"
      InputProps={{
        style: {
          fontSize: "12px",
          direction: direction || "rtl",
          // height: "46px",
        }, // Adjust the font size as needed
      }}
      sx={{
        outline: "none",
        border: "none",
        width: "100%",
        "& input::placeholder": {
          fontSize: placHolderSize,
        },
        "& .MuiInputBase-input": {
          padding: textArea ? "0px 0px" : "12px 16px",
          fontSize: "16px",
        },
        "& .MuiFormLabel-root": {
          fontSize: "16px",
        },
      }}
    />
  );
}
